import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import store from '@/trust-atcs-app/store';
import Popover from '@/shared/components/popover/index.vue';
import { orderBy } from 'lodash';
import FileUploader from '../file-uploader/index.vue';

@Options<RadioButtonWithFiles>({
  components: {
    FileUploader,
    Popover,
  },
  emits: ['validForm'],
})
export default class RadioButtonWithFiles extends Vue {
  @Prop()
  private question!: any;

  @Prop()
  private allQuestions!: any;

  private isFileUploadOptional = false;
  private isFileUploadValid = false;

  @Watch('selectedOption')
  private onSelectedOptionChanged(): void {
    this.question.responses.forEach((r: any, idx: number) => {
      if (r.value == this.selectedOption) {
        this.question.responses[idx].answerIsSelected = true;
        this.isFileUploadOptional = idx === 0 ? false : true;
        this.validationFile();
      } else {
        this.question.responses[idx].answerIsSelected = null;
      }
    });
    this.$emit('validForm', this.validForm());
  }

  private uniqueIdName = null as any;

  private selectedOption = null as any;
  private newWording = '';
  private newLinkedWording = '';
  private obj = null as any;

  private generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  created(): void {
    this.uniqueIdName = 'RadioHorizontal-' + this.generateUUID();
    this.question.responses = orderBy(this.question.responses, 'order', 'asc');
    this.initField();
    const content = store.getters.getPopovers;

    this.newWording = this.question.wording;

    if (this.question.linkedSubQuestion?.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.linkedSubQuestion?.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newLinkedWording = this.question.linkedSubQuestion?.wording.replace('--{{' + popovers + '}}--', '');
    } else {
      this.newLinkedWording = this.question.linkedSubQuestion?.wording;
    }

    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    }
  }

  private initField(): void {
    const defaultSelection = this.question.responses.filter((x: any) => x.answerIsSelected);
    if (defaultSelection.length > 0) {
      this.selectedOption = defaultSelection[0].value;
    }
  }

  private validForm(): boolean {
    return this.selectedOption != null && this.isFileUploadValid;
  }

  private validationFile(): void {
    if (this.question.atcsSubQuestions[0]?.responses?.length > 0) {
      this.isFileUploadValid = true;
    } else {
      this.isFileUploadValid = this.isFileUploadOptional ? true : false;
    }
    this.$emit('validForm', this.validForm());
  }

  private getResponse(linkedSubQuestion: any): string {
    const questionType = linkedSubQuestion.atcsQuestionTypeId;
    let returnValue = '';
    switch (questionType) {
      case 5:
        returnValue = this.formatNumberToCurrencyWithZero(linkedSubQuestion.responses[0].answerCurrency);
        break;
      case 3:
        returnValue = linkedSubQuestion.responses[0].answerNumber;
        break;
      case 21:
        returnValue = this.calculateValue(linkedSubQuestion.developerKey);
        break;
      case 23:
        returnValue = linkedSubQuestion.responses[0].answerTxt;
        break;
    }

    return returnValue;
  }

  private formatNumberToCurrencyWithZero(amount: number): string {
    // format number 1234567.20 to 1,234,567.20
    if (amount != null) {
      return '$  ' + amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    } else {
      return '$ 0';
    }
  }

  private calculateValue(developerKey: string): string {
    let groupValue = 0;
    if (developerKey.endsWith('ComputeGroupA-PlusMinus')) {
      groupValue = this.sumOfGroup('GroupA');
    } else if (developerKey.endsWith('ComputeGroupB-PlusMinus')) {
      groupValue = this.sumOfGroup('GroupB');
    } else if (developerKey.startsWith('ComputeGroupC-MaxAbsoluteDiff')) {
      groupValue = this.maxAbsDiff();
    }

    // Format as currency with commas
    const formattedCurrency = '$ ' + groupValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return formattedCurrency;
  }

  private sumOfGroup(groupName: string): number {
    let sum = 0;
    for (let i = 0; i < this.allQuestions.length; i++) {
      if (this.allQuestions[i].linkedSubQuestion?.developerKey.indexOf(groupName) == 0) {
        let operator = 1;
        if (
          this.allQuestions[i].linkedSubQuestion.developerKey.indexOf('Minus') > 0 &&
          this.allQuestions[i].linkedSubQuestion.developerKey.indexOf('GroupC') !== 0
        ) {
          operator = -1;
        }
        const value = this.allQuestions[i].linkedSubQuestion.responses[0].answerCurrency || 0;
        sum += value * operator;
      }
    }
    return sum;
  }

  private maxAbsDiff(): number {
    const groupC = {} as any;
    groupC[0] = this.sumOfGroup('GroupA');
    groupC[1] = this.sumOfGroup('GroupB');
    groupC[2] = this.sumOfGroup('GroupC');
    // console.log('maxAbsDiff: ', groupC);
    const keys = Object.keys(groupC);
    let maxDiff = 0;
    for (let i = 0; i < keys.length - 1; i++) {
      for (let j = i + 1; j < keys.length; j++) {
        const diff = Math.abs(groupC[keys[i]] - groupC[keys[j]]);
        if (diff > maxDiff) {
          maxDiff = diff;
        }
      }
    }
    return maxDiff;
  }
}
